<template>
  <v-container grid-list-xl>
    <v-layout>
      <v-flex>
        <v-card>
          <v-img src="https://unsplash.it/1110/520?random" aspect-ratio="2.13"></v-img>
          <v-form ref="form" lazy-validation>
            <v-card-text>
              <v-layout class="video-info">
                <v-flex xs4>
                  <p class="video-info-name">НАЗВАНИЕ</p>
                  <v-text-field
                    color="purple"
                    class="video-info-value"
                    v-model="videoName"
                    append-icon="edit"
                    :rules="rules.emptyRules"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 v-if="!edit">
                  <p class="video-info-name">ВЕС</p>
                  <p class="video-info-value">{{videoSize}}</p>
                </v-flex>
                <v-flex xs4>
                  <p class="video-info-name">ДАТА ДОБАВЛЕНИЯ</p>
                  <p class="video-info-value">{{this.today}}</p>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-text>
              <v-layout>
                <v-flex xs4>
                  <p class="video-info-name">НАЗНАЧЕНИЕ</p>
                  <v-text-field
                    v-model="newAppointment"
                    color="purple"
                    placeholder="Enter the appointment"
                    :rules="rules.emptyRules"
                  ></v-text-field>
                  <v-select
                    v-model="selectedPackage"
                    :items="packageList"
                    color="purple"
                    chips
                    label="Package"
                    multiple
                    solo
                  ></v-select>
                </v-flex>
                <v-flex xs8>
                  <p class="video-info-name">ОПИСАНИЕ</p>
                  <v-textarea
                    v-model="newDescription"
                    color="purple"
                    placeholder="Enter a description"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-btn type="submit" dark color="purple" @click.prevent="uploadVideo">add</v-btn>
            <v-btn dark color="purple" @click="$router.go(-1)">cancel</v-btn>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import axios from "axios";

export default {
  name: "editVideo",
  data: () => ({
    edit: false,
    videoInfo: null,
    videoName: "No Name",
    name: "",
    videoSize: 0,
    newAppointment: "",
    newDescription: "",
    today: null,
    packageList: [],
    selectedPackage: [],
    rules: {
      emptyRules: [value => !!value || "This input cannot be empty"]
    }
  }),

  created() {
    axios
      .get(this.$hostname + "/admin/packets", {
        headers: {
          Authorization: localStorage.getItem("token")
        }
      })
      .then(response => {
        console.log(response);
        response.data.data.map(item =>{
          this.packageList.push(item.packet_id)
        });
      });
    console.log(this.$store.state.videoInfo);
    if (this.$store.state.videoInfo) {
      this.edit = this.$store.state.videoInfo.edit
        ? this.$store.state.videoInfo.edit
        : false;
      this.newAppointment = this.$store.state.videoInfo.appointment
        ? this.$store.state.videoInfo.appointment
        : "";
      this.newDescription = this.$store.state.videoInfo.description
        ? this.$store.state.videoInfo.description
        : "";
      this.videoInfo = this.$store.state.videoInfo;
      this.videoName = this.name = this.$store.state.videoInfo.videoName
        ? this.$store.state.videoInfo.videoName
        : this.$store.state.videoInfo.name
            .split(".")
            .slice(0, -1)
            .join(".");
      this.videoSize = this.$store.state.videoInfo.size
        ? (this.$store.state.videoInfo.size / 1000000).toFixed(2) + " mb"
        : "No Data";
      this.today = this.$store.state.videoInfo.date
        ? this.$store.state.videoInfo.date.split(" ")[0]
        : this.getCurrentDate();
      this.selectedPackage = this.$store.state.videoInfo.packet
        ? [this.$store.state.videoInfo.packet]
        : [];
      // console.log(this.selectedPackage)
      // this.newAppointment = this.$store.state.videoInfo.appointment ? this.$store.state.videoInfo.appointment : '';
    } else {
      this.$router.push("/add-video");
    }
  },

  methods: {
    uploadVideo() {
      if (this.edit) {
        console.log(this.$refs.form.validate());
        if (this.$refs.form.validate()) {
          let formData = new FormData();
          formData.append("appointment", this.newAppointment);
          formData.append("description", this.newDescription);
          formData.append("name", this.name);
          formData.append("new_name", this.videoName);
          formData.append(
            "packet",
            this.selectedPackage.length ? this.selectedPackage : 0
          );
          formData.forEach((value, key) => {
            console.log("%s: %s", key, value);
          });
          axios
            .post(this.$hostname + "/admin/video_edit", formData, {
              headers: {
                Authorization: localStorage.getItem("token")
              }
            })
            .then(response => {
              console.log(response);
              this.$router.push("/videos");
            })
            .catch(error => {
              console.log(error);
            });
        }
      } else {
        console.log(this.$refs.form.validate());
        if (this.$refs.form.validate()) {
          let formData = new FormData();
          formData.append("video", this.$store.state.videoInfo);
          formData.append("appointment", this.newAppointment);
          formData.append("description", this.newDescription);
          formData.append("video_name", this.videoName);
          formData.append(
            "packet",
            this.selectedPackage.length ? this.selectedPackage : 0
          );
          formData.forEach((value, key) => {
            console.log("%s: %s", key, value);
          });
          axios
            .post(this.$hostname + "/admin/upload_video", formData, {
              headers: {
                Authorization: localStorage.getItem("token")
              }
            })
            .then(response => {
              console.log(response);
              this.$router.push("/videos");
            })
            .catch(error => {
              console.log(error);
            });
        }
      }
    },
    getCurrentDate() {
      let today = new Date();
      let dd = today.getDate();
      let mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      let todayFormat = yyyy + "-" + mm + "-" + dd;
      return todayFormat;
    }
  }
};
</script>

<style lang="scss">
</style>
